import React from 'react';
import { useNavigate } from 'react-router-dom';
import RTModal from '../common/RTModal';
import RTButton from '../common/RTButton';
import RTSpinner from '../common/RTSpinner';
import '../payments/InvoiceSendSummaryModal.css';

/**
 * Job confirmation modal for bulk WhatsApp template send
 * (same pattern as InvoiceSendSummaryModal).
 */
const TemplateSendJobModal = ({ isOpen, onClose, summaryData }) => {
  const navigate = useNavigate();

  const handleViewJobDetails = () => {
    if (summaryData?.job_id) {
      navigate(`/reports/jobs/${summaryData.job_id}`);
      onClose();
    }
  };

  const handleViewAllJobs = () => {
    navigate('/reports/jobs');
    onClose();
  };

  const renderBody = () => {
    if (!summaryData) return null;

    if (summaryData.status === 'starting') {
      return (
        <div className="summary-modal-content">
          <RTSpinner
            message={
              summaryData.message || 'Starting background processing...'
            }
          />
        </div>
      );
    }

    if (summaryData.status === 'timeout') {
      return (
        <div className="summary-modal-content">
          <div className="summary-info">
            <p>
              <strong>Template:</strong> {summaryData.template_name}
            </p>
            <p>
              <strong>Total Allocations:</strong>{' '}
              {summaryData.total_allocations}
            </p>
            <p className="processing-note">{summaryData.message}</p>
            <div className="job-link-note">
              The background job may still be running. Check the{' '}
              <strong>Background Jobs</strong> report to verify the status.
            </div>
          </div>
          <div className="modal-actions">
            <RTButton variant="secondary" onClick={onClose}>
              Close
            </RTButton>
            <RTButton variant="primary" onClick={handleViewAllJobs}>
              View Background Jobs
            </RTButton>
          </div>
        </div>
      );
    }

    // processing / started
    return (
      <div className="summary-modal-content">
        <div className="summary-info">
          <p>
            <strong>Job ID:</strong> {summaryData.job_id}
          </p>
          <p>
            <strong>Template:</strong> {summaryData.template_name}
          </p>
          <p>
            <strong>Total Allocations:</strong>{' '}
            {summaryData.total_allocations}
          </p>
          <p className="processing-note">
            {summaryData.message ||
              'Processing in background. This may take several minutes.'}
          </p>
          <div className="job-link-note">
            You can view the job status and details in the{' '}
            <strong>Background Jobs</strong> report.
          </div>
        </div>
        <div className="modal-actions">
          <RTButton variant="secondary" onClick={onClose}>
            Close
          </RTButton>
          <RTButton
            variant="primary"
            onClick={handleViewJobDetails}
            disabled={!summaryData.job_id}
          >
            View Job Details
          </RTButton>
        </div>
      </div>
    );
  };

  if (!isOpen) return null;

  return (
    <RTModal
      isOpen={isOpen}
      onClose={onClose}
      title="Template Send Summary"
      size="medium"
    >
      {renderBody()}
    </RTModal>
  );
};

export default TemplateSendJobModal;
